import { get, IHttpRequestConfig, IURLSearchParams } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { IContract, IPageableContractsList } from "./types";

const API = {
  list: "/api/contracts/{companyId}",
  contract: "/api/contracts/{contractId}/{companyId}",
};
interface IContractListParams extends IURLSearchParams {
  companyId?: number;
}

export const fetchContractsList = (params: IContractListParams, options?: IHttpRequestConfig) => {
  const { companyId, ...search } = params;
  const url = compose(API.list, { companyId }, search);
  return get<IPageableContractsList>(url, applyHeaders({}, options)).then(extractDataFromResponse);
};
interface IContractParams extends IContractListParams {
  contractId: number;
}

export const fetchContract = (params: IContractParams, options?: IHttpRequestConfig) => {
  const { companyId, contractId, ...search } = params;
  const url = compose(API.contract, { contractId, companyId }, search);
  return get<IContract>(url, applyHeaders({}, options)).then(extractDataFromResponse);
};
